/** スキャン結果からワンタイムトークン文字列を取り出す */
export function parseTokenFromScan(text: string): string {
  const t = text.trim();
  if (!t) return "";
  try {
    const u = new URL(t);
    const parts = u.pathname.split("/").filter(Boolean);
    if (parts[0] === "api" && parts[1] === "qr" && parts[2]) return parts[2];
    const q = u.searchParams.get("token");
    if (q) return q;
  } catch {
    /* 単純文字列 */
  }
  return t;
}
